module.exports = __webpack_public_path__ + "img/paint-slice_06.43c98f61.jpg";